<template>
	<div id="structure-view" style="display: block;">
		<div class="entry-view" id="custom">
			<div id="room-view" style="transform-origin: top left; position: absolute; z-index: 1;" ref="roomView">
				<VueIdentifyNetwork @network-speed="handleNetworkSpeed">
					<span :slot="loadType">
						<img
							v-if="$root.isImage(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
							:src="$root.asset(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
							style="display: block;"
							width="960px"
							ref="background"
							@load="calcScale()"
						/>
						<video
							v-else-if="$root.isVideo(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
							id="video"
							style="display: block;"
							width="960px"
							muted
							playsinline
							disablepictureinpicture
							loop="loop"
							ref="background"
						>
							<source
								:src="$root.asset(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
								type="video/mp4"
							/>
						</video>
						<youtube
							v-else-if="$root.isYoutubeUrl(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
							:videoId="$root.getYoutubeId(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background, backgroundYoutubeParams)"
							:player-vars="backgroundYoutubeParams"
							style="pointer-events: none;"
							width="960"
							height="530"
							ref="backgroundYoutube"
						></youtube>
						<vimeo-player
							v-else-if="$root.isVimeoUrl(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
							:video-url="structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background"
							:options="backgroundVimeoParams"
							style="pointer-events: none "
							player-width="960"
							player-height="auto"
						></vimeo-player>
						<div v-for="(item, index) in structure.linkToDataList" :key="index">
							<img
								v-if="item.type === 'Image' && !structure.dataMap.backgroundLogin"
								:src="$root.asset(item.value)"
								:style="{
									zIndex: layerMode == true ? structure.linkToDataList.length - index : 0,
									width: item.width + 'px',
									height: item.height + 'px',
									objectFit: $root.setBackgroundSize(item.subType),
									objectPosition: $root.setBackgroundPosition(item),
									top: item.posY + 'px',
									left: item.posX + 'px',
									transform:
										'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
									position: 'absolute',
								}"
							/>
						</div>
						<span
							style="display: none"
							v-for="(item, index) in structureList"
							:key="item+index"
						>
							<img :src="$root.asset(item.background)" />
						</span>
					</span>
				</VueIdentifyNetwork>
			</div>
			<v-row
				class="mx-0"
				:style="{
					position: 'fixed',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					zIndex: layerMode == true && structure.linkToDataList != null ? structure.linkToDataList.length + 1 : 1
				}"
			>
				<v-col cols="12" class="d-flex justify-center align-center">
					<v-form
						ref="form"
						v-model="valid"
						@submit.prevent="login()"
					>
						<v-card
							max-width="350"
							:style="
								$vuetify.breakpoint.smAndUp
									? 'width: 350px;'
									: 'width: 95vw;'
							"
							rounded="xl"
						>
							<v-card-title
								class="title d-flex justify-center align-center mb-4"
								style="color: white"
							>
								<v-img
									v-if="structure.dataMap.logo"
									max-height="100"
									contain
									:src="
										$root.asset(structure.dataMap.logo)
									"
								></v-img>
							</v-card-title>
							<v-card-text>
								<v-text-field
									:disabled="!structure.dataMap.status"
									v-model="email"
									:rules="emailRules"
									label="E-mail"
									dense
									rounded
									filled
									required
								></v-text-field>

								<v-text-field
									:disabled="!structure.dataMap.status"
									v-model="password"
									:rules="passwordRules"
									:type="passwordFieldType"
									:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
									@click:append="switchVisibility"
									label="Password"
									dense
									rounded
									filled
									required
								></v-text-field>
								<v-row
									class="d-flex flex-row-reverse justify-space-between align-center"
									style="margin: 0"
								>
									<v-col cols="12" sm="6">
										<v-btn
											:disabled="!valid || loading"
											class="v-unite-primary"
											type="submit"
											min-width="150"
											depressed
											rounded
											block
											>Login</v-btn
										>
									</v-col>
									<v-col cols="12" sm="6">
										<router-link
											:disabled="!structure.dataMap.status"
											:event="!structure.dataMap.status ? '' : 'click'"
											class="v-unite-primary"
											:to="
												'/' +
												tenantSlug +
												'/' +
												experienceSlug +
												'/forgotpassword'
											"
											>Forgot Password</router-link
										>
									</v-col>
									<v-col cols="12" style="font-size:12px;margin-left:10px;">
										<span> Browser compatibility check
											<a href="https://v-unite.com/browser-check/">https://v-unite.com/ browser-check/</a>
										</span>
									</v-col>
								</v-row>
							</v-card-text>
							<v-progress-linear
								rounded
								v-if="loading"
								:indeterminate="loading"
							></v-progress-linear>
							<div style="height: 20px"></div>
						</v-card>
					</v-form>
				</v-col>
			</v-row>
			<v-row v-if="$store.state.isPoweredBy && footerMarginTop != '0px' " id="footerAja" style="background-color: black" :style="{ marginTop: footerMarginTop }">
				<v-col cols="12" sm="12">
					<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
						<p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
					</div>
                    <div id="v-footer" style="height: 50px; background-color: black" v-else>
						<p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
					</div>
				</v-col>
			</v-row>
		</div>

		<v-dialog v-model="dialogNotifShow" v-if="dialogNotifShow" width="500">
			<v-card style="padding:20px;">
				<!-- <div style="display:flex;justify-content:space-between;">
					<h2 style="margin-bottom:10px;">Whoops! (Unauthorized)</h2>
					<v-btn icon color="secondary" @click="closeNotification">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div> -->
				
				<div class="text-center mb-5">
					<h2 style="margin-bottom: 10px; font-size: larger;"
					>Something Went Wrong (Unauthorized)</h2>
				</div>

				<div class="text-center mt-5 mb-5" style="color:#E26026;font-size:14px;">This experience is not yet active/published</div>
				<div class="text-center mt-5 mr-10 ml-10">
					<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
					style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
				</div>
				<div style="text-align:center;margin-top:20px;">
					<v-btn color="#009ec1" @click="dialogNotifShow = false">Close</v-btn>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<style>
#structure-view .entry-view {
	overflow-x: auto;
	overflow-y: auto;
	width: auto;
	max-width: 100%;
	height: auto;
	margin: 0 auto;
}
.entry-view {
	/* position: relative; */
	margin: 0;
}
audio,
canvas,
progress,
video {
	display: inline-block;
	vertical-align: baseline;
}
</style>

<style scoped>
/* Let's get this party started */
::-webkit-scrollbar {
	height: 0px;
}
</style>

<script>
/* eslint-disable no-unused-vars */
import axios from "axios";
import configuration from "../../configuration";
import { CometChat } from "@cometchat-pro/chat";
import { VueIdentifyNetwork } from 'vue-identify-network';

export default {
	props: ["tenantSlug", "experienceSlug"],
	components: {
		VueIdentifyNetwork
	},
	data() {
		return {
			loadType: 'fast',
			dialog: true,
			valid: true,
			structure: { dataMap: {} },
			email: null,
			emailRules: [
				(v) => !!v || "E-mail is required",
				(v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
			],
			password: null,
			passwordRules: [(v) => !!v || "Please specify password"],
			passwordFieldType: "password",
			structureList: [],
			currentUser: {},
			loading: false,
			baseLocation: axios.defaults.baseURL,
			dialogNotifShow: false,
			experience: null,
			layerMode: false,
			componentKey: Date.now(),
			footerMarginTop: '0px',
			backgroundYoutubeParams: { autoplay: 1, showinfo: 0, controls: 0, mute: 1, loop: 1, playlist: ''},
			backgroundVimeoParams: {autoplay: true, muted: true, title: false, byline: false, portrait:false, controls: false, loop: true},
			isUseCometChat: false
		};
	},
	mounted: function () {
		this.setExperience();
		this.entrance();
		this.setUseCometChat();
		window.onresize = () => {
			this.calcScale();
		};
	},
	methods: {
		setExperience() {
			axios
				.post("/system/public/experience", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug
				})
				.then(response => {
					this.experience = response.data;
					this.layerMode = this.experience.layerMode;
					this.$root.experienceId = this.experience.id;
					this.calcScale();
					this.$store.commit("setIsPoweredBy", this.experience.transitMap.poweredBy);
                    this.$store.commit("setFooterText", this.experience.transitMap.footerText);
				})
				.catch(() => {});
		},
		entrance() {
			axios
				.get(
					"/system/public/structure?tenantSlug=" +
						this.tenantSlug +
						"&experienceSlug=" +
						this.experienceSlug
				)
				.then((response) => {
					this.structure = response.data;
					// Check if small asset is exist and use it
					let vm = this
					this.$root.isImageExist(this.$root.largeAsset(this.structure.background), function(status) {
						if (status) {
							vm.structure.background = vm.$root.largeAsset(vm.structure.background);
						}
					});
					this.$root.isImageExist(this.$root.largeAsset(this.structure.dataMap.backgroundLogin), function(status) {
						if (status) {
							vm.structure.dataMap.backgroundLogin = vm.$root.largeAsset(vm.structure.dataMap.backgroundLogin);
						}
					});
					this.$nextTick(() => {
						if (this.$root.isVideo(this.structure.dataMap.backgroundLogin ? this.structure.dataMap.backgroundLogin : this.structure.background)) {
							var video = document.getElementById("video");
							video.load();
							let vm = this;
							video.addEventListener('loadeddata', () => {
								let scale = document.body.clientWidth / (1920 * 0.5);
								let height = this.$refs.roomView.clientHeight * scale;
								this.footerMarginTop = height + "px";

								if(video.readyState === 4) {
									this.calcScale();
									document.getElementsByClassName("v-main__wrap")[0].scrollLeft = (video.getBoundingClientRect().width-window.innerWidth)/2;
								}
							});
						}
					});
					this.prefetchStructureList(this.structure.experienceId);
					this.dialogNotifShow = !this.structure.dataMap.status;
				})
				.catch(() => {});
		},
		login() {
			this.loading = true;
			this.$store.commit("resetLiveNotification");
			this.$store
				.dispatch("login", {
					type: "Experience_User",
					email: this.email,
					password: this.password,
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
				})
				.then(() => {
					this.$store.commit('setFitToWidth', this.experience.dataMap.fitToHeight);
					let activityLog = { type: "Logging_into_the_event" };
					this.$root.saveActivityLog(activityLog);
					this.getMainStructure();
				})
				.catch(() => {
					this.loading = false;
				})
				.finally(() => {});
		},
		setUseCometChat() {
			axios
				.get("/system/public/isUseCometChat")
				.then(response => {
					if (response.data) {
						this.isUseCometChat = response.data;
					}
				})
				.catch(() => {});
		},
		async cometchatLogin(apiKey) {
			let staffChatId = this.$store.state.principal.chatId.split(";");
			let uid = null;
			if (staffChatId.length > 1) {
				for (let i = 0; i < staffChatId.length; i++) {
					if (
						staffChatId[i].includes(
							this.$store.state.principal.experienceId + "-"
						)
					) {
						uid = staffChatId[i];
					}
				}
			} else {
				uid = staffChatId;
			}

			// Get Comet Chat Current User
			try {
				await CometChat.login(uid, apiKey);
				this.currentUser = await CometChat.getLoggedinUser(); //SDK
			} catch (error) {
				this.cometChatErrorNotif(error);
			}

			// Edit Comet Chat Role
			let role = "default";
			let experienceId = this.$store.state.principal.experienceId;
			uid = this.currentUser.uid;
			let data = { role: role };
			try {
				await axios.post("/system/chat/user/edit/role", {
					experienceId,
					uid,
					data,
				});
			} catch (error) {
				console.log("Role edit failed: ", error);
			}

			// Join event bus for Cometchat online users
			await this.joinEventBus();
		},
		async joinEventBus() {
			let busId = this.$store.state.principal.experienceId + "-bus";
			let groupList = await new CometChat.GroupsRequestBuilder()
				.joinedOnly(true)
				.setSearchKeyword(busId)
				.setLimit(100)
				.build()
				.fetchNext();

			let busFound = false;
			for (let i of groupList) {
				if (i.guid == busId) {
					busFound = true;
				}
			}

			let group;
			if (!busFound) {
				try {
					group = await CometChat.joinGroup(busId, "public", "");
				} catch (error) {
					this.cometChatErrorNotif(error);
				}
			}

			await CometChat.sendMessage(
				new CometChat.TextMessage(
					busId,
					JSON.stringify({ type: "Login" }),
					CometChat.RECEIVER_TYPE.GROUP
				)
			);
		},
		cometChatErrorNotif(error) {
			let notification = {
				title: "CometChat error",
				content: {
					errorList: [error.message],
					fieldErrorList: [],
					noticeList: [],
					type: "NOTIFICATION",
				},
			};
			this.$store.commit("showNotification", notification);
		},
		getMainStructure() {
			axios
				.get(
					"/system/structure/main?experienceId=" +
						this.structure.experienceId
				)
				.then((response) => {
					this.$router.push(
						"/" +
							this.tenantSlug +
							"/" +
							this.experienceSlug +
							"/hall/" +
							response.data.slug
					);
					location.reload();
				})
				.catch(() => {});
		},
		prefetchStructureList(experienceId) {
			axios
				.get("/system/structure/list?experienceId=" + experienceId)
				.then((response) => {
					let list = [];
					let videoList = [];
					for (let entry of response.data) {
						if (entry && entry.background) {
							if (this.$root.isImage(entry.background)) {
								list.push(entry);
							} else if (this.$root.isVideo(entry.background)) {
								if (
									!(
										entry.dataMap &&
										entry.dataMap.prefetch == "false"
									)
								) {
									videoList.push(entry);
								}
							}
						}
					}
					this.structureList = list.concat(videoList);
				})
				.catch(() => {});
		},
		switchVisibility() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		calcScale() {
			var custom = document.getElementById("custom");
			var room = document.getElementById("room-view");
			var scale = 1;
			if (document.body.clientWidth >= 960 && !this.$vuetify.breakpoint.mobile) {
				if (room != null) {
					if (!this.experience.dataMap.fitToHeight) {
						let scale = document.body.clientWidth / (1920 * 0.5);
						room.style.transform = "scale(" + scale + ")";
						let height = this.$refs.roomView.clientHeight * scale;
						this.footerMarginTop = height + "px";
					} else {
						this.$nextTick(function() {
							scale = window.innerHeight / (1080 * 0.5);
							let height = window.innerHeight;
							if (this.$refs.background && this.$refs.background.clientHeight > (1080 * 0.5)) {
								scale = height/this.$refs.background.clientHeight;
							}
							custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
							room.style.transform = "scale(" + scale + ")";
							room.style.position = "absolute";
							document.getElementsByClassName("v-main")[0].style.backgroundColor = "black";
						});
					}
				}
			} else {
				custom.style.paddingLeft = "0";
				this.$nextTick(function() {
					scale = window.innerHeight / (1080 * 0.5);
					let height = window.innerHeight;
					if (this.$refs.background && this.$refs.background.clientHeight > (1080 * 0.5)) {
						scale = height/this.$refs.background.clientHeight;
					}
					if (document.body.clientWidth > (room.scrollWidth * scale)) {
						custom.style.paddingLeft = (document.body.clientWidth - Math.abs((960 - (1 - scale) * (1920 * 0.5))))/2 + "px";
					}
					room.style.transform = "scale(" + scale + ")";
				});
				document.getElementsByClassName("v-main")[0].id = "room";
				document.getElementsByClassName("v-main")[0].style.backgroundColor = "black";
			}
			this.$nextTick(() => {
				if (this.$refs.background) {
					document.getElementsByClassName("v-main__wrap")[0].scrollLeft = ((this.$refs.background.clientWidth*scale)-window.innerWidth)/2;
				}
			});
		},
		handleNetworkSpeed(speed) {
			console.log('downlink: ', speed);

			let isConnectionKnown = speed == 'Unknown' ? false : true;

			if(isConnectionKnown == false) {
				this.loadType = 'unknown';
			}

			if (isConnectionKnown == true && speed < 1) {
				this.$store.commit('setShowVideoTransition', false);
			} else {
				this.$store.commit('setShowVideoTransition', true);
			}
		}
	},
};
</script>